export enum SessionStorageKey {
  IMAGE_POPUP_DISMISSED = 'imagePopupDismissed'
}
